const TestimonialAppList=[
    {
        id: 1,
        src: require('../assets/giftya-1.png'),
        alt : "Image",
    },
    {
        id: 2,
        src: require('../assets/giftya-2.png'),
        alt : "Image",
    },
    {
        id: 3,
        src: require('../assets/giftya-3.png'),
        alt : "Image",
    },
    {
        id: 4,
        src: require('../assets/giftya-5.png'),
        alt : "Image",
    },
    {
        id: 5,
        src: require('../assets/granny.png'),
        alt : "Image",
    },
    {
        id: 6,
        src: require('../assets/menu.png'),
        alt : "Image",
    },
]


export default TestimonialAppList;